import {
  BookOpenIcon,
  IdentificationIcon,
  LibraryIcon,
  PencilAltIcon,
  QrcodeIcon,
} from '@heroicons/react/outline';
import { IoBookSharp } from 'react-icons/io5';

export const MENU_ROUTES = [
  {
    label: 'Książki',
    href: '/dashboard/books',
    icon: BookOpenIcon,
    name: 'books',
    permission: 'all',
    children: [
      { label: 'Posiadane', name: 'owned', href: '/dashboard/books/' },
      { label: 'Niedostępne', name: 'unavailable', href: '/dashboard/books/unavailable' },
      { label: 'Pożyczone', name: 'borrowed', href: '/dashboard/books/borrowed' },
      { label: 'Otrzymane', name: 'recieved', href: '/dashboard/books/recieved' },
    ],
  },
  {
    label: 'Biblioteka',
    href: '/dashboard/bookshelves',
    icon: LibraryIcon,
    name: 'maps',
    permission: 'all',
    children: [
      { label: 'Mapa półek', name: 'map', href: '/dashboard/bookshelves/map' },
      { label: 'Moje półki', name: 'shelves', href: '/dashboard/bookshelves/shelves' },
    ],
  },
  {
    label: 'Karty biblioteczne',
    href: '/dashboard/generate-pdf',
    icon: QrcodeIcon,
    name: 'generate-pdf',
    permission: 'all',
  },
  {
    label: 'Artykuły',
    href: '/dashboard/articles/add',
    icon: PencilAltIcon,
    name: 'create',
    permission: 'all',
  },
  // ------------------
  // Permissions Routes
  // ------------------
  {
    label: 'Publikacje',
    href: '/dashboard/publisher',
    icon: IoBookSharp,
    name: 'publisher',
    permission: 'is_publisher',
  },
  {
    label: 'Katalog',
    href: '/dashboard/isbn',
    icon: IdentificationIcon,
    name: 'isbn',
    permission: 'is_superuser',
  },
];
